import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  borderRadius8,
  boxShadowBlack8,
} from 'approot/shared/styles/borders.style';
import {
  grey1,
  grey4,
  grey7,
  grey8,
  purple7,
} from 'approot/shared/styles/colours.style';
import { spacing4, spacing8 } from 'approot/shared/styles/spacing.style';
import { font18 } from 'approot/shared/styles/typography.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const ToolSizeContainerRange = styled.div`
  ${boxShadowBlack8}
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  display: flex;
  align-items: center;
  height: ${rem(64)};
  position: relative;
  padding: ${rem(spacing8)} ${rem(spacing4)} ${rem(4)} ${rem(spacing4)};
  width: ${rem(290)};

  /* Rotate to make it vertical */
  transform: rotate(-90deg);
`;

type ToolSizePreviewProps = {
  $size: number;
};

export const ToolSizePreview = styled.div<ToolSizePreviewProps>`
  background-color: ${grey1};
  border: 1px solid ${grey8};
`;

export const ToolSizePreviewContainer = styled.div`
  position: absolute;
  left: -50px;
  width: 50px;
  height: 50px;
  ${flexCentreAlignCss}
`;

const rangeHandle = css`
  background: ${grey1};
  border: 1px solid ${purple7};
  border-radius: ${rem(20)};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  height: ${rem(32)};
  width: ${rem(32)};
`;

export const ToolRange = styled.input.attrs({
  type: 'range',
})`
  background: transparent;
  position: relative;
  -webkit-appearance: none;
  width: 100%;
  height: 100%;
  z-index: 3;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    ${rangeHandle}
  }

  &::-moz-range-thumb {
    ${rangeHandle}
  }

  &::-ms-thumb {
    ${rangeHandle}
  }

  &:focus {
    &::-webkit-slider-thumb {
      border-color: ${purple7};
    }
    &::-moz-range-thumb {
      border-color: ${purple7};
    }
    &::-ms-thumb {
      border-color: ${purple7};
    }
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: ${rem(34)};
  }
  &::-moz-range-track {
    width: 100%;
    height: ${rem(34)};
  }
  &::-ms-track {
    width: 100%;
    height: ${rem(34)};
  }
`;

export const ToolTrack = styled.div`
  position: relative;
  width: 100%;
  height: ${rem(32)};
`;

export const ToolBgTrack = styled.div`
  background-color: ${grey4};
  border-radius: ${rem(borderRadius8)};
  height: ${rem(12)};
  position: absolute;
  left: ${rem(8)};
  right: ${rem(8)};
  top: 50%;
  margin-top: -${rem(6)};
  overflow: hidden;
`;

type ToolTrackProps = {
  $width: number;
};
export const ToolFillTrack = styled.div<ToolTrackProps>`
  background-color: ${purple7};
  border-radius: ${rem(borderRadius8)};
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  width: ${props => props.$width}%;
`;

export const ToolSizeValue = styled.div`
  ${font18}
  color: ${grey7};
  min-width: ${rem(32)};
  text-align: center;
  transform: rotate(90deg);
`;
